<script setup lang="ts">
import {computed, ref} from 'vue';
import {useRoute} from 'vue-router';
import BrandedLogo from './components/BrandedLogo.vue';
import {inject} from "vue";
import {PortalAuthKey} from "./plugins/auth.ts";
import User from "./models/User.ts";
import AuthLayout from "./layouts/AuthLayout.vue";

const route = useRoute()

const error = computed(() => route.query.error)

const auth = inject(PortalAuthKey);

const user = ref<User>(auth.authState.user);

const permissions = ref<any[]>(auth.authState.permissions);

// Checks if an OAuth redirect is in progress
const hasOauthParams = computed(() => {
  return auth.authState.redirecting;
});

</script>

<template>
  <AuthLayout>
    <v-sheet v-if="hasOauthParams" width="450" class="mx-auto pa-12 text-center" rounded="lg" elevation="8">
      <v-progress-circular
          :size="100"
          color="primary"
          indeterminate
          class="mb-5"
          :width="8"
      ></v-progress-circular>
      <h2 class="text-h5 mb-6">Redirecting to App</h2>
      <p class="mb-4 text-medium-emphasis text-body-2">
        Please wait while we take you to your application...
      </p>
    </v-sheet>
    <v-sheet v-else width="450" class="mx-auto my-4 pa-12" rounded="lg" elevation="8">
      <BrandedLogo></BrandedLogo>
      <br>
      <h3 class="text-center d-flex align-center justify-center">
        <v-icon class="mx-2">mdi-human-greeting</v-icon>
        Welcome, {{ user.first_name }}!
      </h3>
      <br>
      <v-alert v-if="error?.length > 0" color="error">
        <p>{{ error }}</p>
      </v-alert>
      <br>
      <v-divider></v-divider>
      <v-list v-if="permissions.length > 0">
        <v-list-item prepend-icon="mdi-application" v-for="app in permissions" rounded
                     :title="app.application.title" :href="app.application.url" target="_blank">
          <template #append>
            <v-chip v-if="app.application.type === 'beta'" size="x-small" color="warning" variant="flat">BETA</v-chip>
            <v-chip v-if="app.application.type === 'dev'" size="x-small" color="error" variant="flat">DEV</v-chip>
          </template>
        </v-list-item>
      </v-list>
      <v-list v-else>
        <v-list-item>No Applications Available</v-list-item>
      </v-list>
      <v-divider></v-divider>
      <v-list>
        <v-list-item rounded prepend-icon="mdi-account-circle" title="My Account" to="/account"></v-list-item>
        <v-list-item v-if="user.isAdmin === 1" rounded prepend-icon="mdi-security" title="Admin Tools"
                     to="/admin/dashboard"></v-list-item>
      </v-list>
      <v-divider></v-divider>

      <v-btn color="primary" block class="mt-2" size="large" @click="() => auth.logout()">
        <span class="mx-2">Log Out</span>
      </v-btn>
      <div class="mt-2">
        <p class="text-body-2 text-center">Copyright
          &copy; {{ new Date(Date.now()).getFullYear() }} OIX®</p>
        <p class="text-body-2 text-center mb-2">All Rights Reserved.</p>
      </div>
    </v-sheet>
  </AuthLayout>
</template>

<style>
</style>